import React from 'react'

import { Button } from 'v2/ui'

export const CogIcon = ({ onClick }: { onClick: () => void }): React.ReactElement => (
    <Button variant="adminSecondary" buttonSize="sm" onClick={onClick} icon="cog">
        Edit
    </Button>
)
